import { FinanceWorkspacePayrollLandingDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useSeePayrollLanding = (skip?: boolean) => {
  const { data, loading } = useQuery(FinanceWorkspacePayrollLandingDocument, {
    skip,
  })

  const seePayrollLanding =
    !data?.financialWorkspace.payrollLandingBannersConnection.edges[0]?.node
      .payrollSummaryUploadedLastYear

  return {
    seePayrollLanding,
    loading,
  }
}
